import React from "react";
import Navbar from "../components/navbar";
import AdminSidebar from "../components/sidebar";
import { useAgentsAdminContext } from "../providers/agents-admin.provider";

const AgentsAdminLayout = ({ children }) => {
  const { sponsor, config } = useAgentsAdminContext();
  // Colores del detalle (getDetails); si no vienen, se usa el gradiente hardcoded.
  const hasColors = Boolean(
    config?.bgGradientColorPrimary && config?.bgGradientColorSecondary,
  );

  const color = () => {
    switch (sponsor) {
      case "virgin":
        return "from-white to-[#E32B24]";
      case "micelu":
        return "from-white to-blueFinance";
      case "icali":
        return "from-white to-[#2D1366]";
      case "cellsite":
        return "from-white to-[#121212]";
      case "enel":
        return "from-white to-[#461E7D]";
      case "celufio":
        return "from-white to-[#39667A]";
      case "credicell":
        return "from-white to-[#0090c4]";
      case "celuplanet":
        return "from-[#0a407e] to-[#01b7d7]";
      case "cellzone":
        return "from-[#e41218] to-[#ffffff]";
      case "credicelexpress":
        return "from-[#d5c08a] to-[#ffffff]";
      case "iphoneros":
        return "from-[#ffffff] to-[#000000]";
      case "pochocell":
        return "from-[#ffffff] to-[#1070b7]";
      case "ofertacel":
        return "from-[#ffffff] to-[#000000]";
      case "movilexpress":
        return "from-[#ffffff] to-[#000000]";
      case "smartket":
        return "from-white to-[#f04c11]";
      case "alocentralmovil":
        return "from-white to-[#E21F13]";
      case "thaniacel":
        return "from-white to-[#000000]";
      case "smartgadgets":
        return "from-white to-[#1FA1CA]";
      case "equismobile":
        return "from-white to-[#5FBE42]";
      case "icali2":
        return "from-white to-[#2D1366]";
      case "toptrading":
        return "from-white to-[#192B53]";
      case "greenelectronics":
        return "from-[#059AB0] to-[#79D75A]";
      default:
        return "from-white to-blueFinance";
    }
  };

  return (
    <div
      className={`flex h-screen overflow-hidden 2xl:overflow-hidden ${
        hasColors ? "" : `bg-gradient-to-b ${color()}`
      }`}
      style={
        hasColors
          ? {
              background: `linear-gradient(to bottom, ${config!.bgGradientColorPrimary}, ${config!.bgGradientColorSecondary})`,
            }
          : undefined
      }
    >
      <Navbar />
      <AdminSidebar />
      {children}
    </div>
  );
};
export default AgentsAdminLayout;
